import UserForm from "../components/form/UserForm"
import { Card } from "../components/ui/card"
import SpeechToText from "../components/Learning/SpeechToText"
import AvatarForm from "../components/form/AvatarForm"
export default function Profile () {
  return (
    <div className="w-[80%] mx-auto space-y-4 py-8">
      <h1 className=" text-xl font-[Phudu] font-bold">Quản lý thông tin</h1>
      <div className="grid lg:grid-cols-[1fr_2fr] gap-8">
        <Card className="p-8">
          <AvatarForm />
        </Card>
        <Card className="p-8">
          <UserForm />
        </Card>
      </div>
    </div>
  )
}
